<div class="upsell-wait bg-bhmd-blue">
  <div class="upsell-wait__container mx-auto p-4 text-center text-white">
    <span class="font-bold">WAIT... YOUR ORDER IS NOT COMPLETE!&nbsp;</span>
    <span>&nbsp;Do not hit the "back" button, it can cause multiple charges on your card.</span>
  </div>
</div>